import React, { useState } from 'react';

import { Tabs, type TabOption } from '@/components/chariot-ui';
import { DiscoveryPanel } from '@/sections/customerManagement/components/masterDashboard/DiscoveryPanel';
import { EnrichmentPluginsPanel } from '@/sections/customerManagement/components/masterDashboard/EnrichmentPluginsPanel';

const masterTabs: TabOption[] = [
  { label: 'Discovery', value: 'discovery' },
  { label: 'Enrichment Plugins', value: 'enrichment' },
];

export const MasterDashboard: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<TabOption>(masterTabs[0]);

  return (
    <div className="flex h-full flex-col gap-4">
      <p className="text-chariot-text-secondary text-sm">
        Manage master-level integrations and enrichment plugins across all
        tenants
      </p>
      <Tabs
        tabs={masterTabs}
        selected={selectedTab}
        onSelect={setSelectedTab}
        variant="primary"
      />
      <div className="h-full overflow-y-auto pb-6">
        {selectedTab.value === 'enrichment' && <EnrichmentPluginsPanel />}
        {selectedTab.value === 'discovery' && <DiscoveryPanel />}
      </div>
    </div>
  );
};
